<template>
  <div>
    <!-- <span>日本語</span> -->
    <transition name="fade">
      <div class="loader-wrap" v-if="screenLoading">
        <div class="loader">Loading...</div>
      </div>
    </transition>
    <app-header v-show="headerView" />
    <app-contents v-on:window-open="windowOpen" />
    <div class="footerStyle">
      <app-footer v-show="footerView" />
    </div>
  </div>
</template>

<script>
const Header = () => import(/* webpackChunkName: "header" */ "./components/common/Header.vue");
const Footer = () => import(/* webpackChunkName: "footer" */ "./components/common/Footer.vue");
import Contents from "./components/Contents.vue";
import axios from "axios";

export default {
  data() {
    return {
      headerView: true,
      footerView: true,
    };
  },
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "app-contents": Contents,
  },
  created: function() {
    axios
      .post("/api/authentication/isCleverlyHome")
      .then((res) => {
        if (res.data.result == 1) {
          this.$store.commit("setServerLogged", false);
        } else {
          this.$store.commit("setServerLogged", true);
          this.$store.commit("setCleverlyHomeFlg", res.data.cleverlyHomeFlg);
        }
      })
      .catch(() => {
        this.$router.push({name: "Error"});
      });
    axios
      .post("/api/authentication/isManualDisp")
      .then((res) => {
        if (res.data.result == 1) {
          this.$store.commit("setServerLogged", false);
        } else {
          this.$store.commit("setServerLogged", true);
          this.$store.commit("setManualDispFlg", res.data.manualDispFlg);
        }
      })
      .catch(() => {
        this.$router.push({name: "Error"});
      });
    axios
      .post("/api/authentication/isMainDomain")
      .then((res) => {
        if (res.data.result == 1) {
          this.$store.commit("setServerLogged", false);
        } else {
          this.$store.commit("setServerLogged", true);
          this.$store.commit("setIsMainDomain", res.data.isMainDomain);
        }
      })
      .catch(() => {
        this.$router.push({name: "Error"});
      });
  },
  computed: {
    screenLoading: {
      get() {
        return this.$store.state.screenLoading;
      },
    },
  },
  methods: {
    windowOpen: function() {
      this.headerView = false;
      this.footerView = false;
    },
  },
};
</script>

<style lang="scss">
.footerStyle {
  flex: 1;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
